import { render, staticRenderFns } from "./JobDeviceDetailsCard.vue?vue&type=template&id=027bf1c4&scoped=true"
import script from "./JobDeviceDetailsCard.vue?vue&type=script&lang=js"
export * from "./JobDeviceDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./JobDeviceDetailsCard.vue?vue&type=style&index=0&id=027bf1c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027bf1c4",
  null
  
)

export default component.exports